var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-items-center"},[_c('b-spinner',{staticClass:"loading-spinner",attrs:{"variant":"primary","label":"Spinning","small":""}}),_c('strong',{staticClass:"text-primary loading-text faa-flash animated faa-slow"},[_vm._v("Loading...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }